import React, { Fragment, useEffect, useRef, useState } from "react";
import { Col, Row, Form, Button, Dropdown, OverlayTrigger, Tooltip, Card, Modal, ProgressBar, Image } from 'react-bootstrap';
import { GrDocumentText } from "react-icons/gr";
import whatsappPic from "../../assets/img/mobileScreens/Whatsapp.png"
import { CheckCircleIcon, ChevronDownIcon, ClockIcon, PlusIcon, ShieldExclamationIcon } from "@heroicons/react/solid";
import { MdOutlineContentCopy, MdOutlineDoNotDisturbAlt, MdTextFields } from "react-icons/md";
import { ImImages } from "react-icons/im";
import { FcPlus } from "react-icons/fc";
import { MdOutlineVideocam } from "react-icons/md";
import { IoDocumentTextOutline } from "react-icons/io5";
import { DropCarouselImage, DropCarouselVideo, DropImagesForm, DropMediaFilesForm, DropVideosForm } from "components/Forms";
import { XCircleIcon } from "@heroicons/react/outline";
import PhoneInput from "react-phone-input-2";
import { CreateForm } from "components/Modals";
import moment from "moment-timezone";
import { useCreateWhatsappTempMutation, useWabaForEuMutation } from "Services/services";
import { useHistory } from "react-router-dom";
import { Routes } from "routes";
import { PiArrowSquareUpRight, PiMicrosoftExcelLogoLight, PiPhone } from "react-icons/pi";
import { RiFileWord2Fill } from "react-icons/ri";
import { AiFillFilePdf } from "react-icons/ai";
import Select from 'react-select';


export const WhatsappTemplateComponent = () => {
    // Get the id from localStorage
    const userData = localStorage.getItem('TOKEN');
    const userObject = JSON.parse(userData);
    const user_id = userObject.id;

    const [showModal, setShowModal] = useState(false);
    const [progress, setProgress] = useState(0);
    const [reason, setReason] = useState('');
    const [variant, setVariant] = useState('primary');

    const formRef = useRef(null);
    const history = useHistory();
    // This will return the form input
    const handleCloseModal = () => {
        setShowModal(false);
        setTimeout(() => {
            setProgress(0);
        }, 100);
        setReason('');
        setVariant('primary');
    };
    // This will reset the form inputs
    const handleRefresh = () => {
        if (formRef.current) {
            formRef.current.reset();
        }
        setValidated(false);
        setShowModal(false);
        setTimeout(() => {
            setProgress(0);
        }, 100);
        history.push({
            pathname: Routes.Templates.path,
            state: { tab: "WhatsApp" }
        });
        setReason('');
        setVariant('primary');
    };
    useEffect(() => {
        if (showModal) {
            const interval = setInterval(() => {
                setProgress(prevProgress => {
                    if (prevProgress >= 100) {
                        clearInterval(interval);
                        return 100;
                    }
                    return Math.min(prevProgress + 2.5, 95);   //95 automatic, 100 only after API response
                });
            }, 100);
        }
        fetchWabaNum();
    }, [showModal]);

    const [numberOptions, setNumberOptions] = useState([]);
    const [selectedNumber, setSelectedNumber] = useState('');
    const [selectedWaba, setSelectedWaba] = useState('');


    const [getWaba] = useWabaForEuMutation();
    const fetchWabaNum = () => {
        getWaba({ user_id: user_id })
            .then((response) => {
                if (response?.data?.statusCode === 200) {
                    const options = response?.data?.data.map(data => ({
                        label: data.mobile,
                        value: data.mobile,
                        waba: data.wa_id
                    }))
                    setNumberOptions(options || [])
                } else {
                    setNumberOptions([]);
                }
            })
            .catch((error) => {
                setNumberOptions([]);
            });
    }

    const [category, setCategory] = useState('Marketing');
    const handleCategory = (e) => {
        setCategory(e.target.value);
        if (e.target.value === 'Utility') {
            setFormat('interactive');
        }
    }
    //-------------->>>>>>>>>>>>>>>>>>>>> Authentication content start------------
    const [disclaimer, setDisclaimer] = useState(false);
    const [warning, setWarning] = useState(false);
    const [authValues, setAuthValues] = useState({ warning_expiryTime: '', disclaimer_otp: '' });
    const handleAuthValues = (e) => {
        const regexTime = /^(?:[0-9]|[1-8][0-9]|90)$/;
        const regexCode = /^\d{0,8}$/;
        if (e.target.name === 'warning_expiryTime') {
            if (regexTime.test(e.target.value)) {
                setAuthValues((prevContent) => ({
                    ...prevContent,
                    [e.target.name]: e.target.value
                }));
            }
        }
        else if (e.target.name === 'disclaimer_otp') {
            if (regexCode.test(e.target.value)) {
                setAuthValues((prevContent) => ({
                    ...prevContent,
                    [e.target.name]: e.target.value
                }));
            }
            // setAuthBody((prevValue) => ({
            //     ...prevValue,
            //     auth_body: (prevValue.auth_body || '').replace(`${authValues.disclaimer_otp || '{{1}}'} is your verification code. For Your Security, do not share this code.`, `${e.target.value} is your verification code. For Your Security, do not share this code.`)
            // }));
            // }
        }
    }

    // when we switch the options
    const handleAuthContent = (e) => {
        if (e.target.name === 'disclaimer') {
            setDisclaimer(!disclaimer);
            // if (e.target.checked) {
            //     setAuthBody((prevValue) => ({
            //         ...prevValue,
            //         auth_body: (prevValue.auth_body || '') + `${authValues.disclaimer_otp || '{{1}}'} is your verification code. For Your Security, do not share this code.`
            //     }));
            // } else {
            //     setAuthBody((prevValue) => ({
            //         ...prevValue,
            //         auth_body: (prevValue.auth_body || '').replace(`${authValues.disclaimer_otp || '{{1}}'} is your verification code. For Your Security, do not share this code.`, '')
            //     }));
            // }

        } else {
            setWarning(!warning);
        }
    };
    // body and footer
    // const handleAuthBody = (e) => {
    //     const { name, value } = e.target;
    //     setAuthBody((prev) => ({
    //         ...prev,
    //         [name]: value,
    //     }));
    // };

    // //variables
    // const [authInputFields, setAuthInputFields] = useState([]);
    // const AddAuthVars = () => {
    //     setAuthInputFields([...authInputFields, ""]);
    // };
    // const handleAuthInputChange = (index, event) => {
    //     const values = [...authInputFields];
    //     values[index] = event.target.value;
    //     setAuthInputFields(values);
    // };
    // const handleDeleteInput = (index) => {
    //     const newArray = [...authInputFields.slice(0, index), ...authInputFields.slice(index + 1)];
    //     setAuthInputFields(newArray);
    // };

    //<<<<<<<<<<<<<<<<<<<<<-------------------Authentication content end------------


    // const [templType, setTemplType] = useState('Standard');
    // const handleTemplateType = (e) => {
    //     setTemplType(e.target.value);
    //     if (e.target.value === 'Dynamic') {
    //         setFormat('interactive');
    //     }
    // }

    // ----------------FROMAT FOR CAROUSEL---------------
    const [format, setFormat] = useState('interactive');    //sub-category
    const handleMesgFormat = (e) => {
        setFormat(e.target.value);
        //handles default selected header type for LTO/copy-code
        if (e.target.value === 'limited_time_offer' || e.target.value === 'carousel') {
            setHeaderCarousel('image');
        } else if (e.target.value === 'copy_code') {
            setHeaderCarousel('text');
        }
    }
    const [header, setHeader] = useState('none');
    const handleHeader = (e) => {
        // if the user chooses no header but after choosing any other header type
        if (e.target.value === 'none') {
            delete FormFields.header;
            setPreview();
        }
        setHeader(e.target.value);
    }

    //--------------------------->>>>>>>>>>>>>>>> CAROUSEL CARDS
    const [headerCarousel, setHeaderCarousel] = useState('image');
    const handleHeaderCarousel = (e) => {
        setHeaderCarousel(e.target.value);
    }
    const [cardsHeader, setCardsHeader] = useState({});
    const handleCarouselMedia = (e) => {
        if (e.target.name === 'image' || e.target.name === 'video') {
            if (format === 'carousel') {
                setCardsHeader({
                    ...cardsHeader,
                    header_type: e.target.name,
                    header_example: e.target.value
                });
            } else if (format === 'limited_time_offer') {
                setCardsHeader({
                    ...cardsHeader,
                    type: e.target.name,
                    example: e.target.value
                });
            }
            setPreview(e.target.preview);

            // console.log('we got Media ID:::::::::', e.target.preview);
        }
    };
    // create
    const [cards, setCards] = useState([]);
    const handleCreateCard = () => {
        if (cards.length < 10) { // Ensure a maximum of 10 cards
            const newCard = {
                body: { text: "", example: [] }, // Default body structure
                buttons: defaultButtons.length
                    ? defaultButtons.map((btn) => ({ ...btn }))
                    : []
            };

            setCards((prev) => [...prev, newCard]); // Add the new card to the state
        } else {
            alert("You can only have a maximum of 10 cards!");
        }
    };
    const AddCardBodyVars = (cardIndex) => {
        const updatedCards = [...cards];
        updatedCards[cardIndex].body.example.push("");
        setCards(updatedCards);
    };
    // delete card
    const handleDeleteCard = (cardIndex) => {
        setCards((prev) => prev.filter((_, index) => index !== cardIndex));
    };
    //BODY & variables inputs
    const handleCardBodyChange = (index, event) => {
        const updatedCards = [...cards];
        updatedCards[index].body.text = event.target.value;
        setCards(updatedCards);
        // console.log('changed body', cards);
    };
    const handleCardBodyVarsChange = (cardIndex, varIndex, event) => {
        const updatedCards = [...cards];
        updatedCards[cardIndex].body.example[varIndex] = event.target.value;
        setCards(updatedCards);
        // console.log('changes', cards);
    };
    const handleDeleteCardBodyVars = (cardIndex, varIndex) => {
        const updatedCards = [...cards];
        updatedCards[cardIndex].body.example.splice(varIndex, 1);
        setCards(updatedCards);
        // console.log('removed', cards);
    };
    //Buttons
    const [defaultButtons, setDefaultButtons] = useState([]);
    const [cardBtnTypes, setCardBtnTypes] = useState([]);
    const ChooseCardBtnType = (type) => {
        if (cards[0].buttons.length < 2) {
            // Create a new button based on its type
            const newButton = { type };

            // Add specific fields based on type
            if (type === "quick_reply") {
                Object.assign(newButton, { text: "" });
            } else if (type === "static") {
                Object.assign(newButton, { type: "static", label: "", website: "" });
            } else if (type === "call_to_action") {
                if (cards[0].buttons.find(btn => btn.type === "call_to_action")) {
                    alert("Only one Call Button Allowed!");
                    return;
                } else {
                    Object.assign(newButton, { label: "", contact_no: "" });
                }
            }

            // Update the default buttons
            setDefaultButtons((prev) => [...prev, newButton]);

            // Apply the new button to all existing cards
            setCards((prevCards) =>
                prevCards.map((card) => ({
                    ...card,
                    buttons: [...card.buttons, newButton]
                }))
            );
        } else {
            alert("Only 2 buttons allowed!");
        }
    };

    const handleCardBtnChange = (cardIndex, buttonIndex, field, value) => {
        const updatedCards = [...cards];
        const card = updatedCards[cardIndex];

        card.buttons = card.buttons.map((button, index) =>
            index === buttonIndex ? { ...button, [field]: value } : button
        );

        const cardbuttonTypes = card.buttons.map(button => button.type);
        const transformedButtonTypes = cardbuttonTypes.map(type => {
            if (type === 'static' || type === 'dynamic') {
                return 'url';
            }
            if (type === 'call_to_action') {
                return 'phone';
            }
            return type; // Leave other types unchanged
        });
        setCardBtnTypes(transformedButtonTypes);

        // console.log('btn types', cardBtnTypes);

        setCards(updatedCards);
        // console.log('Updated Cards:', updatedCards);
    };

    const deleteCardButton = (buttonIndex) => {
        // console.log('button index', buttonIndex);


        // Update the default buttons by removing the button at the specified index
        setDefaultButtons((prevButtons) => prevButtons.filter((_, index) => index !== buttonIndex));

        // Update all cards to reflect the change, removing the button at the specified index
        setCards((prevCards) =>
            prevCards.map((card) => ({
                ...card,
                buttons: card.buttons.filter((_, index) => index !== buttonIndex), // Remove button at the specified index
            }))
        );

        const updatedButtonTypes = [...cardBtnTypes];
        updatedButtonTypes.splice(buttonIndex, 1);
        setCardBtnTypes(buttonTypes);

        // console.log('btn types', updatedButtonTypes);
        // console.log('deleted', cards);
    };
    //CAROUSEL CARDS END <<<<<<<<<<<<<<<<<<<<----------------------------

    //HEADER variables
    const [headerVars, setHeaderVars] = useState([]);
    const AddHeaderVars = () => {
        setHeaderVars([...headerVars, ""]);
    };
    const handleVarChange = (index, event) => {
        const values = [...headerVars];
        values[index] = event.target.value;
        setHeaderVars(values);
    };
    const handleDeleteVars = (index) => {
        const newArray = [...headerVars.slice(0, index), ...headerVars.slice(index + 1)];
        setHeaderVars(newArray);
    };

    //body variables
    const [inputFields, setInputFields] = useState([]);
    const AddVars = () => {
        setInputFields([...inputFields, ""]);
    };
    const handleInputChange = (index, event) => {
        const values = [...inputFields];
        values[index] = event.target.value;
        setInputFields(values);
    };
    const handleDeleteBodyInput = (index) => {
        const newArray = [...inputFields.slice(0, index), ...inputFields.slice(index + 1)];
        setInputFields(newArray);
    };

    //Buttons
    const [textButtons, setTextButtons] = useState([]);
    const [urlButtons, setUrlButtons] = useState([]);
    const [phoneButtons, setPhoneButtons] = useState([]);
    const [formButtons, setFormButtons] = useState([]);

    // handle button counts
    const ChooseBtnType = (type) => {
        switch (type) {
            case 'text': {
                if (textButtons.length < 10) {
                    setTextButtons(prev => [...prev, { id: Date.now() }]);
                }
                break;
            }
            case 'url': {
                if (urlButtons.length < 2) {
                    setUrlButtons(prev => [...prev, { id: Date.now(), type: "static" }]);
                }
                break;
            }
            case 'phone': {
                if (phoneButtons.length < 1) {
                    setPhoneButtons(prev => [...prev, { id: Date.now() }]);
                }
                break;
            }
            case 'form': {
                if (formButtons.length < 1) {
                    setFormButtons(prev => [...prev, { id: Date.now(), formName: '' }]);
                }
                break;
            }
            default: {
                break;
            }
        }
    };
    // handle inputs
    const handleFormChange = (type, id, field, value) => {
        switch (type) {
            case 'text':
                setTextButtons(prev => prev.map(btn => btn.id === id ? { ...btn, [field]: value } : btn));
                break;
            case 'url':
                setUrlButtons(prev => prev.map(btn => btn.id === id ? { ...btn, [field]: value } : btn));
                break;
            case 'phone':
                setPhoneButtons(prev => prev.map(btn => btn.id === id ? { ...btn, [field]: value } : btn));
                break;
            case 'form':
                setFormButtons(prev => prev.map(btn => btn.id === id ? { ...btn, formName: value } : btn));
                break;
            default:
                break;
        }
    };
    // delete buttons
    const deleteButton = (type, id) => {
        switch (type) {
            case 'text':
                setTextButtons(prev => prev.filter(btn => btn.id !== id));
                break;
            case 'url':
                setUrlButtons(prev => prev.filter(btn => btn.id !== id));
                break;
            case 'phone':
                setPhoneButtons(prev => prev.filter(btn => btn.id !== id));
                break;
            case 'form':
                setFormButtons(prev => prev.filter(btn => btn.id !== id));
                break;
            default:
                break;
        }
    };
    // LTO buttons
    const [ltoBtns, setLtoBtns] = useState([
        {
            type: 'copy_code',
            example: ''
        },
        {
            type: 'static',
            label: '',
            website: ''
        }])
    const handleLTOBtn = (type, field, value) => {
        switch (type) {
            case 'code':
                setLtoBtns(prev => prev.map((btn, index) => index === 0 ? { ...btn, [field]: value } : btn));
                break;
            case 'url':
                setLtoBtns(prev => prev.map((btn, index) => index === 1 ? { ...btn, [field]: value } : btn));
                break;
            default:
                break;
        }
    }
    const [LTOText, setLTOText] = useState('');
    const handleLTOText = (e) => {
        setLTOText(e.target.value);
    }
    // Copy-Code buttons
    const [codeBtns, setCodeBtns] = useState([
        {
            type: 'copy_code',
            example: ''
        }
    ])
    const ChooseCodeBtnType = (type) => {
        switch (type) {
            case 'quick_reply': {
                setCodeBtns(prev => [...prev, { type: 'quick_reply', text: '' }]);
                break;
            }
            case 'url': {
                setCodeBtns(prev => [...prev, { type: 'static', label: '', website: '' }]);
                break;
            }
            case 'call_to_action': {
                setCodeBtns(prev => [...prev, { type: 'call_to_action', label: '', contact_no: '' }]);
                break;
            }
            default: {
                break;
            }
        }
    };
    const deleteCodeBtn = (type) => {
        setCodeBtns(prev => prev.filter(btn => btn.type !== type));
        // button type postdata me rakhna hai agar to hi ye kaam ayega
    }
    const handleCodeBtn = (type, field, value) => {
        if (type === 'code') {
            setCodeBtns(prev => prev.map((btn, index) => index === 0 ? { ...btn, [field]: value } : btn));
        } else {
            setCodeBtns(prev => prev.map((btn, index) => index === 1 ? { ...btn, [field]: value } : btn));
        }
    }


    // GO TO FORM MODAL
    const [showCreateFormModal, setShowCreateFormModal] = useState(false);
    const toggleCreateFormModal = () => {
        setShowCreateFormModal(!showCreateFormModal);
    };

    //handle values + HEADER types
    const [FormFields, setFormFields] = useState({});
    const [preview, setPreview] = useState();
    const handleform2 = (e) => {
        if (e.target.name === 'document' || e.target.name === 'image' || e.target.name === 'video') {
            setFormFields({
                ...FormFields,
                header: {
                    type: e.target.name,  // Dynamically set the type based on the input name (file, image, video)
                    example: e.target.value
                },
            });
            setPreview(e.target.preview);

        } else if (e.target.name === 'header') {
            setFormFields({
                ...FormFields,
                header: {
                    type: "text",
                    text: e.target.value,
                },
            });
        } else {
            setFormFields({
                ...FormFields,
                [e.target.name]: e.target.value,
            });
        }
    };



    const [validated, setValidated] = useState(false);
    const submitWhatsapp = (e) => {
        e.preventDefault();

        // Prevent the default form submission
        const form = e.currentTarget;
        if (form.checkValidity() === false || !selectedNumber) {
            e.stopPropagation();
            setValidated(true);

            window.scrollTo({
                top: 0,
                behavior: "smooth", // or 'auto' if you want instant scroll
            });
            return;
        }

        // Handle buttons
        let allButtonData = [...textButtons,
        ...urlButtons,
        ...phoneButtons];
        const keyToRemove = 'id';
        const updatedArray = allButtonData.map(obj => {
            const { [keyToRemove]: _, ...rest } = obj;
            return rest;
        });

        //btns for combined btns
        const updatedTextButtons = textButtons.map(btn => ({
            ...btn,
            type: "Quickreply",
        }))
        const combinedBtnsArray = [
            ...updatedTextButtons,
            ...urlButtons,
            ...phoneButtons].map(obj => {
                const { [keyToRemove]: _, ...rest } = obj;
                return rest;
            });

        let buttons = {};
        if (textButtons.length > 0 && (urlButtons.length > 0 || phoneButtons.length > 0)) {
            buttons = {
                type: "combined_buttons",
                elements: combinedBtnsArray
            };
        } else if (urlButtons.length > 0 || phoneButtons.length > 0) {
            buttons = {
                type: "call_to_action",
                elements: updatedArray
            };
        } else if (textButtons.length > 0) {
            buttons = {
                type: "quick_reply",
                elements: updatedArray
            };
        }
        // header
        let bindheader = {};
        if (FormFields.header && FormFields.header.type === "text" && headerVars.length > 0) {
            bindheader = {
                ...FormFields.header,
                example: headerVars
            }
        } else {
            bindheader = FormFields.header
        }

        setValidated(true);
        if ((category === 'Marketing') && (format === 'interactive')) {

            const postdata = {
                template_name: FormFields.template_name,
                template_language: ["en"],
                template_type: (header === 'none' || header === 'text') ? 'TEXT_TEMPLATE' : 'MEDIA_TEMPLATE',
                template_category: "MARKETING",
                header: bindheader,
                body: {
                    text: FormFields.template_content,
                    example: inputFields
                },
                footer: {
                    text: FormFields.footer
                },
                buttons: buttons,
                wa_id: selectedWaba,
            };

            handleCreateWhatsapp(postdata);
        }
        else if ((category === 'Marketing') && (format === 'carousel')) {

            if (cards.length < 2) {
                setReason('Minimum 2 cards are required');
                setVariant('warning');
                setShowModal(true);
                setProgress(100);
            }
            else if (cards.length <= 10) {
                const postdata = {
                    template_name: FormFields.template_name,
                    template_language: ["en"],
                    template_type: "CAROUSEL",
                    template_category: "MARKETING",
                    body: {
                        text: FormFields.template_content,
                        example: inputFields
                    },
                    cards: {
                        header_type: cardsHeader.header_type,
                        header_example: cardsHeader.header_example,
                        button_types: cardBtnTypes,
                        elements: cards
                    },
                    wa_id: selectedWaba,
                };
                console.log('post data in CAROUSEL', postdata);

                handleCreateWhatsapp(postdata);
            }

        }
        else if ((category === 'Marketing') && (format === 'limited_time_offer')) {
            const postdata = {
                template_name: FormFields.template_name,
                template_language: ["en"],
                template_type: "template",
                template_category: "MARKETING",
                template_sub_category: "LTO",
                // components: {
                body: {
                    text: FormFields.template_content,
                    example: inputFields
                },
                header: {
                    type: cardsHeader.header_type,
                    example: cardsHeader.header_example,
                },
                buttons: {
                    type: "limited_time_offer",
                    elements: ltoBtns
                },
                limited_time_offer: {
                    text: LTOText,
                    has_expiration: true
                },
                // },
                wa_id: selectedWaba,
            }
            console.log('post data in limited_time_offer sub.cat.', postdata);
            handleCreateWhatsapp(postdata);
        } else if ((category === 'Marketing') && (format === 'copy_code')) {
            const postdata = {
                template_name: FormFields.template_name,
                template_language: ["en"],
                template_type: "template",
                template_category: "MARKETING",
                template_sub_category: "COPY CODE",
                body: {
                    text: FormFields.template_content,
                    example: inputFields
                },
                header: bindheader,
                buttons: {
                    type: "combined_buttons",
                    elements: codeBtns
                },
                wa_id: selectedWaba,
            }
            console.log('post data in copy code sub.cat.', postdata);
            handleCreateWhatsapp(postdata);
        } else if ((category === 'Utility')) {
            const postdata = {
                template_name: FormFields.template_name,
                template_language: ["en"],
                template_type: (header === 'none' || header === 'text') ? 'TEXT_TEMPLATE' : 'MEDIA_TEMPLATE',
                template_category: 'UTILITY',
                header: bindheader,
                body: {
                    text: FormFields.template_content,
                    example: inputFields
                },
                footer: {
                    text: FormFields.footer
                },
                buttons: buttons,
                wa_id: selectedWaba,
            };
            console.log('post data in utility', postdata);
            handleCreateWhatsapp(postdata);
        }
        else if (category === 'Authentication') {

            const postdata = {
                template_name: FormFields.template_name,
                template_language: ["en"],
                template_type: "AUTHENTICATION",
                template_category: "AUTHENTICATION",
                body: {
                    add_security_recommendation: disclaimer
                },
                footer: warning ? {
                    code_expiration_minutes: authValues.warning_expiryTime
                } : {},
                buttons: {
                    type: "OTP",
                    otp_type: "COPY_CODE",
                    text: authValues.disclaimer_otp
                },
                wa_id: selectedWaba,
            }
            console.log('post data in auth', postdata);
            handleCreateWhatsapp(postdata);
        };
    };

    const [createWhatsapp] = useCreateWhatsappTempMutation();
    const handleCreateWhatsapp = async (postdata) => {
        try {
            setShowModal(true);
            const success = await createWhatsapp(postdata);

            if (success?.data?.statusCode === 200) {
                setReason(success?.data?.message);
                setVariant('tertiary');
                setProgress(100);
            } else if (success?.data?.statusCode > 300) {
                setReason(success?.data?.data?.errorMessage || 'Upload failed!');
                setVariant('warning');
                setProgress(100);
            }
        } catch (error) {
            setReason('Upload failed' || error);
            setVariant('warning');
            setShowModal(true);
            setProgress(100);
        }
    };



    //preview
    const date = moment();
    const currentTime = date.format("h:mm A");

    // variables replacement
    const highlightAndReplaceHeader = (content) => highlightAndReplaceVariables(content, headerVars);
    const highlightAndReplaceContent = (content) => highlightAndReplaceVariables(content, inputFields);
    // Generic function to highlight and replace variables in a string
    const highlightAndReplaceVariables = (content, variablesArray) => {
        if (typeof content !== 'string') {
            return content; // Return as-is if not a string
        }

        // Split the content into parts based on {{digit}} pattern
        const parts = content.split(/(\{\{\d+\}\})/);

        return parts.map((part, index) => {
            if (/\{\{\d+\}\}/.test(part)) {
                // Extract the number inside {{ }}
                const number = parseInt(part.match(/\d+/)[0], 10); // Get the digit inside {{ }}

                // Get the replacement value from variablesArray (adjusting for 0-based index)
                const replacementValue = variablesArray[number - 1] || part; // Fallback to original if not found

                return (
                    <span key={index} style={{ color: 'blue' }}>
                        {replacementValue}
                    </span>
                );
            }
            return (
                <span key={index} style={{ whiteSpace: "pre-wrap" }}>
                  {part}
                </span>
              );
        });
    };
    // buttons preview
    const buttonTypes = [
        { buttons: textButtons, content: (button) => <span className="btn-txt">{button.text}</span> },
        {
            buttons: urlButtons, content: (button) => <>
                <PiArrowSquareUpRight /><span className="btn-txt">{button.label}</span>
            </>
        },
        {
            buttons: phoneButtons, content: (button) => <>
                <PiPhone /><span className="btn-txt">{button.label}</span>
            </>
        }
    ];

    return (
        <Fragment>
            <div className="d-flex flex-row-reverse gap-3">

                {/* -------------------------mobile preview code------------------------- */}
                <div className="img-cont">
                    <img src={whatsappPic} alt="whatsapp preview" />
                    <div className="preview-cont">

                        {(FormFields?.header || FormFields.template_content || FormFields?.footer) && (category !== 'Authentication') && (format !== 'carousel') &&
                            <div className="whatsBody">
                                {FormFields?.header?.type === "text" && <span className="w-header">{highlightAndReplaceHeader(FormFields?.header?.text)}</span>}
                                {FormFields?.header?.type === "image" && <Image src={preview} className="w-image" />}
                                {FormFields?.header?.type === "video" &&
                                    <video controls width="100%" className="w-image">
                                        <source src={preview} type="video/mp4" />
                                        Unsupported video tag by browser.
                                    </video>}
                                {FormFields?.header?.type === "document" &&
                                    <span className="w-doc">
                                        {preview === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ? <RiFileWord2Fill style={{ color: '#2A5293' }} />
                                            : preview === 'application/pdf' ? <AiFillFilePdf style={{ color: '#CB3724' }} />
                                                : preview === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ? <PiMicrosoftExcelLogoLight style={{ color: '#4AA66A' }} />
                                                    : <GrDocumentText />}

                                    </span>
                                }

                                <span className="w-body">{highlightAndReplaceContent(FormFields?.template_content)}</span>
                                <br />
                                {FormFields.footer && <span className="w-footer">{FormFields?.footer}</span>}
                                <div className="time_box">
                                    <span className="ms-auto">{currentTime}</span>
                                </div>

                                {((format === 'interactive') && (buttonTypes.some(({ buttons }) => buttons.length > 0))) ?
                                    <>
                                        <div className="wdivider" />
                                        {buttonTypes.map(({ buttons, content }, typeIndex) => (
                                            buttons.map((button, buttonIndex) => (
                                                <div className="whatsButton" key={button.id || `${typeIndex}-${buttonIndex}`}>
                                                    {content(button)}
                                                </div>
                                            ))
                                        ))}
                                    </>
                                    :
                                    (format === 'limited_time_offer') ?
                                        <>
                                            <div className="wdivider" />
                                            <div className="whatsButton">
                                                <MdOutlineContentCopy /> Copy Code
                                            </div>
                                            <div className="whatsButton">
                                                <PiArrowSquareUpRight /><span className="btn-txt">{ltoBtns[1].label}</span>
                                            </div>
                                        </>
                                        : (format === 'copy_code') ?
                                            <>
                                                <div className="wdivider" />
                                                <div className="whatsButton">
                                                    <MdOutlineContentCopy /> Copy Code
                                                </div>
                                                {codeBtns.length > 1 &&
                                                    <div className="whatsButton">
                                                        {codeBtns[1].type === 'text' ? <span className="btn-txt">{codeBtns[1].text}</span>
                                                            : (codeBtns[1].type === 'static' || codeBtns[1].type === 'dynamic') ?
                                                                <>
                                                                    <PiArrowSquareUpRight /><span className="btn-txt">{codeBtns[1].label}</span>
                                                                </>
                                                                :
                                                                <>
                                                                    <PiPhone /><span className="btn-txt">{codeBtns[1].label}</span>
                                                                </>
                                                        }
                                                    </div>}
                                            </>
                                            : ''
                                }
                            </div>
                        }
                        {(format === 'carousel') && (FormFields?.template_content || preview) &&
                            <>
                                <div className="whatsBody">
                                    <span className="w-body">{highlightAndReplaceContent(FormFields?.template_content)}</span>
                                    <br />
                                    <div className="time_box">
                                        <span className="ms-auto">{currentTime}</span>
                                    </div>
                                </div>
                                <div className="cards-container cards-slider">
                                    {cards.map((card, index) => (
                                        <div key={index} className="cardsBody">
                                            {headerCarousel === "image" && <Image src={preview} className="w-image" />}
                                            {headerCarousel === "video" &&
                                                <video controls width="100%" className="w-image">
                                                    <source src={preview} type="video/mp4" />
                                                    Unsupported video tag by browser.
                                                </video>}
                                            <span className="w-body">{highlightAndReplaceVariables(card.body.text, card.body.example)}</span>
                                            {card.buttons.length > 0 &&
                                                <>
                                                    <div className="wdivider" />
                                                    {card.buttons.map((button, buttonIndex) => (
                                                        <div className="whatsButton" key={buttonIndex}>
                                                            {button.type === "quick_reply" ? <span className="btn-txt">{button.text}</span>
                                                                : button.type === "call_to_action" ? <><PiPhone /><span className="btn-txt">{button.label}</span></>
                                                                    : <><PiArrowSquareUpRight /><span className="btn-txt">{button.label}</span></>
                                                            }
                                                        </div>
                                                    ))}
                                                </>
                                            }
                                        </div>
                                    ))}
                                </div>
                            </>
                        }
                        {(category === 'Authentication') &&
                            <div className="whatsBody">
                                {disclaimer && <span className="w-body"><b>{authValues.disclaimer_otp || '{{1}}'}</b> is your verification code. For Your Security, do not share this code.</span>}
                                <br />
                                {warning && <span className="w-footer">{`This code expires in ${authValues.warning_expiryTime} minutes.`}</span>}
                                <div className="time_box">
                                    <span className="ms-auto">{currentTime}</span>
                                </div>
                                {disclaimer && (
                                    <>
                                        <div className="wdivider" />
                                        <div className="whatsButton">
                                            <MdOutlineContentCopy /> Copy Code
                                        </div>
                                    </>
                                )}

                            </div>
                        }
                    </div>
                </div>


                <Form noValidate validated={validated} ref={formRef} onSubmit={submitWhatsapp} className="w-100">
                    <div className="mid-section-scroll">

                        <div className="card p-3 m-0">
                            <Row>
                                <Form.Group as={Col} xs={12} lg={6}>
                                    <Form.Label>Meta Registered Number<span className="text-danger"> * </span></Form.Label>
                                    <Select
                                        options={numberOptions}
                                        placeholder={"Select Number"}
                                        className="mb-0"
                                        value={selectedNumber}
                                        onChange={(selectedOption) => {
                                            setSelectedNumber(selectedOption);
                                            setSelectedWaba(selectedOption.waba);
                                        }}
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                borderColor: validated && !selectedWaba ? '#dc3545' : validated && selectedWaba ? '#65BB82' : provided.borderColor,
                                                borderRadius: '0.75rem',
                                            }),
                                        }}
                                    />
                                    {validated && !selectedNumber &&
                                        <div className="invalid-feedback d-block">
                                            Meta Number selection is required.
                                        </div>}
                                </Form.Group>
                            </Row>
                        </div>

                        <div className="card p-3 mt-3 m-0">
                            <Row>
                                <Form.Group as={Col} lg={6} className="mb-3 withChars">
                                    <Form.Label>Template Name<span className="text-danger"> * </span></Form.Label>
                                    <Form.Control required type="text" placeholder="Enter Template Name" pattern="^[a-z0-9_]+$" maxLength={100} name="template_name" onChange={handleform2} title="Template Name must be only lowercase alphanumeric characters or underscores" />
                                    <p className="chars_count">{FormFields.template_name === undefined ? "0" : FormFields.template_name.length}/100</p>
                                    <Form.Control.Feedback type="invalid">
                                        Please provide a valid Template name.
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Category<span className="text-danger"> * </span></Form.Label>
                                    <Select
                                        name="category"
                                        value={{ value: category, label: category }}
                                        onChange={(selectedOption) => handleCategory({ target: { value: selectedOption?.value || '' } })}
                                        options={[
                                            { value: "Marketing", label: "Marketing" },
                                            { value: "Utility", label: "Utility" },
                                            { value: "Authentication", label: "Authentication" },
                                        ]}
                                        placeholder="Select Category"
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                borderColor: validated && !category ? '#dc3545' : validated && category ? '#65BB82' : '#ced4da',
                                                borderRadius: '0.75rem',
                                            }),
                                        }}
                                    />
                                </Form.Group>

                                <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Language<span className="text-danger"> * </span></Form.Label>
                                    <Select
                                        isDisabled={true}
                                        options={[
                                            { value: "English", label: "English" },
                                        ]}
                                        value={{ value: "English", label: "English" }}
                                        placeholder="Select Language"
                                    />
                                </Form.Group>

                                {/* {category !== 'Authentication' && <Form.Group as={Col}>
                            <Form.Label>Template Type</Form.Label>
                            <Form.Select name="template_type" onChange={handleTemplateType}>
                                <option defaultValue>Standard</option>
                                <option>Dynamic</option>
                            </Form.Select>
                        </Form.Group>} */}
                                {category === 'Marketing' && <Form.Group as={Col} lg={6} className="mb-3">
                                    <Form.Label>Sub-Category<span className="text-danger"> * </span></Form.Label>
                                    <Select
                                        name="template_type"
                                        value={{ value: format, label: format === 'interactive' ? 'Interactive' : format === 'carousel' ? 'Carousel' : format === 'limited_time_offer' ? 'Limited Time Offer' : 'Copy Code' }}
                                        onChange={(selectedOption) => handleMesgFormat({ target: { value: selectedOption?.value || '' } })}
                                        options={[
                                            { value: "interactive", label: "Interactive" },
                                            { value: "carousel", label: "Carousel" },
                                            { value: "limited_time_offer", label: "Limited Time Offer" },
                                            { value: "copy_code", label: "Copy Code" },
                                        ]}
                                        placeholder="Select Sub-Category"
                                        styles={{
                                            control: (provided, state) => ({
                                                ...provided,
                                                borderColor: validated && !format ? '#dc3545' : validated && format ? '#65BB82' : '#ced4da',
                                                borderRadius: '0.75rem',
                                            }),
                                        }}
                                    />
                                </Form.Group>}
                            </Row>

                            {/* {category !== 'Authentication' && <Row className="">
                        <div className="d-flex">
                            <div style={{ backgroundColor: '#E5E7EB', borderRadius: '10px' }}>
                                <Button onClick={handleMesgFormat} variant={format === 'interactive' ? "secondary" : "white"} value={"interactive"} className="m-2"><IoIosPhonePortrait /> Interactive</Button>
                                <Button disabled={templType === 'Dynamic'} onClick={handleMesgFormat} variant={format === 'carousel' ? "secondary" : "white"} value={"carousel"} className="m-2"><TbCarouselHorizontal /> Carousel</Button>
                            </div>
                        </div>
                    </Row>} */}
                        </div>

                        {/* <<<<<<<<<<<<<<<<---------------------------------Utility+Interactive--header------------------------------>>>>>>>>>>>>>>>>>>>> */}

                        {format === 'interactive' && category !== 'Authentication' && <div className="card p-3 mt-3 m-0">
                            <Row>
                                <Form.Group as={Col} lg={12} className="mb-3">
                                    <Form.Label>Header (Optional)</Form.Label>
                                    <div className="d-flex flex-wrap">
                                        <Button onClick={handleHeader} variant={header === 'none' ? "success text-white" : "gray-200"} value={"none"} className="m-2"><MdOutlineDoNotDisturbAlt /> None</Button>
                                        <Button onClick={handleHeader} variant={header === 'text' ? "success text-white" : "gray-200"} value={"text"} className="m-2"><MdTextFields /> Text</Button>
                                        <Button onClick={handleHeader} variant={header === 'image' ? "success text-white" : "gray-200"} value={"image"} className="m-2"><ImImages />  Image</Button>
                                        <Button onClick={handleHeader} variant={header === 'video' ? "success text-white" : "gray-200"} value={"video"} className="m-2"><MdOutlineVideocam /> Video</Button>
                                        <Button onClick={handleHeader} variant={header === 'document' ? "success text-white" : "gray-200"} value={"document"} className="m-2"><IoDocumentTextOutline /> Document</Button>
                                    </div>
                                </Form.Group>
                            </Row>
                            {header === 'text' && <Row className="mb-3">
                                <Form.Group as={Col} lg={12} className="withChars">
                                    <div className="d-flex justify-content-between">
                                        <Form.Label>Header Text<span className="text-danger"> * </span></Form.Label>
                                        <Button onClick={AddHeaderVars} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold">
                                            <FcPlus className="icon icon-xs me-2" />Add Variable
                                        </Button>
                                    </div>
                                    <Form.Control type="text" required placeholder="Enter Header" maxLength={60} name="header" onChange={handleform2} />
                                    <p className="chars_count ta">{FormFields.header === undefined ? "0" : (FormFields.header.text).length}/60</p>
                                </Form.Group>
                                <Row>
                                    {headerVars.map((input, index) => (
                                        <Form.Group as={Col} xs={6} md={4} key={index} className="mt-3">
                                            <Form.Label className="fw-normal">{`Var {{${index + 1}}}`}<span className="text-danger"> * </span></Form.Label>
                                            <div className="d-flex align-items-center">
                                                <Form.Control
                                                    type="text"
                                                    placeholder="Value"
                                                    value={input}
                                                    onChange={(event) => handleVarChange(index, event)}
                                                    name="template_variables"
                                                />
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                    <Card.Link className="ms-2 hover-text-danger" onClick={() => handleDeleteVars(index)}>
                                                        <XCircleIcon className="icon icon-xs" />
                                                    </Card.Link>
                                                </OverlayTrigger>
                                            </div>
                                        </Form.Group>
                                    ))}
                                </Row>
                            </Row>}
                            {header === 'image' && <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <DropImagesForm onFilesUploaded={handleform2} />
                                </Form.Group>
                            </Row>}
                            {header === 'video' && <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <DropVideosForm onFilesUploaded={handleform2} />
                                </Form.Group>
                            </Row>}
                            {header === 'document' && <Row className="mb-3">
                                <Form.Group as={Col}>
                                    <DropMediaFilesForm onFilesUploaded={handleform2} />
                                </Form.Group>
                            </Row>}
                        </div>}

                        {/* <<<<<<<<<<<<<<<<-----------------------------------carousel+LTO+copy-code--header------------------------------>>>>>>>>>>>>>>>>>>>> */}
                        {format !== 'interactive' && category === 'Marketing' &&
                            <div className="card p-3 mt-3 m-0">
                                <Row>
                                    <Form.Group as={Col} lg={12} className="mb-3">
                                        <Form.Label>Header<span className="text-danger"> * </span></Form.Label>
                                        <div className="d-flex flex-wrap">
                                            {format === 'copy_code' ? <Button onClick={handleHeaderCarousel} variant={headerCarousel === 'text' ? "success text-white" : "gray-200"} value={"text"} className="m-2"><MdTextFields /> Text</Button>
                                                :
                                                <>
                                                    <Button onClick={handleHeaderCarousel} variant={headerCarousel === 'image' ? "success text-white" : "gray-200"} value={"image"} className="m-2"><ImImages />  Image</Button>
                                                    <Button onClick={handleHeaderCarousel} variant={headerCarousel === 'video' ? "success text-white" : "gray-200"} value={"video"} className="m-2"><MdOutlineVideocam /> Video</Button>
                                                </>
                                            }
                                        </div>
                                    </Form.Group>
                                </Row>
                                {headerCarousel === 'text' && <Row className="mb-3">
                                    <Form.Group as={Col} lg={12} className="withChars">
                                        <div className="d-flex justify-content-between">
                                            <Form.Label>Header Text<span className="text-danger"> * </span></Form.Label>
                                            <Button onClick={AddHeaderVars} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold">
                                                <FcPlus className="icon icon-xs me-2" />Add Variable
                                            </Button>
                                        </div>
                                        <Form.Control type="text" required placeholder="Enter Header" maxLength={60} name="header" onChange={handleform2} />
                                        <p className="chars_count ta">{FormFields.header === undefined ? "0" : (FormFields.header.text).length}/60</p>
                                    </Form.Group>
                                    <Row>
                                        {headerVars.map((input, index) => (
                                            <Form.Group as={Col} xs={6} md={4} key={index} className="mt-3">
                                                <Form.Label className="fw-normal">{`Var {{${index + 1}}}`}<span className="text-danger"> * </span></Form.Label>
                                                <div className="d-flex align-items-center">
                                                    <Form.Control
                                                        type="text"
                                                        placeholder="Value"
                                                        value={input}
                                                        onChange={(event) => handleVarChange(index, event)}
                                                        name="template_variables"
                                                    />
                                                    <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                        <Card.Link className="ms-2 hover-text-danger" onClick={() => handleDeleteVars(index)}>
                                                            <XCircleIcon className="icon icon-xs" />
                                                        </Card.Link>
                                                    </OverlayTrigger>
                                                </div>
                                            </Form.Group>
                                        ))}
                                    </Row>
                                </Row>}
                                {headerCarousel === 'image' && <Row className="mb-3">
                                    <Form.Group as={Col}>
                                        <DropCarouselImage onFilesUploaded={handleCarouselMedia} />
                                    </Form.Group>
                                </Row>}
                                {headerCarousel === 'video' && <Row className="mb-3">
                                    <Form.Group as={Col}>
                                        <DropCarouselVideo onFilesUploaded={handleCarouselMedia} />
                                    </Form.Group>
                                </Row>}
                            </div>
                        }
                        {/* <<<<<<<<<<<<<<<<-----------------------------------carousel-header------------------------------>>>>>>>>>>>>>>>>>>>> */}

                        {/* <<<<<<<<<<<<<<<<-----------------------------------AUTHENTICATION------------------------------->>>>>>>>>>>>>>>>>>>> */}
                        {category === 'Authentication' &&
                            <div className="card p-3 mt-3 m-0">
                                <Row className="mb-3">
                                    <Form.Group as={Col}>
                                        <Form.Label>Content<span className="text-danger"> * </span></Form.Label>
                                        <Form.Check
                                            type="switch"
                                            label="Security Disclaimer"
                                            id="switch1"
                                            htmlFor="switch1"
                                            name="disclaimer"
                                            onChange={handleAuthContent}
                                        />
                                        <Form.Check
                                            type="switch"
                                            label="Expiration Warning"
                                            id="switch2"
                                            htmlFor="switch2"
                                            name="warning"
                                            onChange={handleAuthContent}
                                        />
                                        {warning && <div className="d-flex align-items-center">
                                            <p className="m-0">Expiry Time:</p>
                                            <Form.Control
                                                required
                                                className="mx-2 w-25"
                                                type="text"
                                                placeholder="ex:0-90"
                                                name="warning_expiryTime"
                                                value={authValues.warning_expiryTime}
                                                onChange={handleAuthValues}
                                            />
                                            <p className="m-0">min</p>
                                        </div>}
                                    </Form.Group>
                                </Row>
                                <Row className="mb-3">
                                    <Form.Group as={Col}>
                                        <Form.Label>Header (Optional)</Form.Label>
                                        <div className="d-flex flex-wrap">
                                            <Button variant="success text-white" value={"none"}><MdOutlineDoNotDisturbAlt /> None</Button>
                                        </div>
                                    </Form.Group>
                                </Row>

                                <Form.Group className="mb-3">
                                    {/* <div className="d-flex justify-content-between">
                                    <Form.Label>Content Body</Form.Label>
                                    <Button onClick={AddAuthVars} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold">
                                        <FcPlus className="icon icon-xs me-2" />Add Variable
                                    </Button>
                                </div> */}
                                    <Form.Control as="textarea" rows="5" disabled value={disclaimer ? `${authValues.disclaimer_otp || '{{1}}'} is your verification code. For Your Security, do not share this code.` : '-- Set Disclaimer to show content --'} />
                                    {/* <Form.Control.Feedback type="invalid">
                                    Please provide a valid Message Content.
                                </Form.Control.Feedback> */}
                                </Form.Group>

                                {/* <Row className="mb-3">
                                {authInputFields.map((input, index) => (
                                    <Form.Group as={Col} key={index}>
                                        <Form.Label>Var {index + 1}</Form.Label>
                                        <div className="d-flex align-items-center">
                                            <Form.Control
                                                type="text"
                                                placeholder="Value"
                                                value={input}
                                                onChange={(event) => handleAuthInputChange(index, event)}
                                                name="auth_variables"
                                            />
                                            <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                <Card.Link className="ms-2" onClick={() => handleDeleteInput(index)}>
                                                    <XCircleIcon className="icon icon-xs hover-text-danger" />
                                                </Card.Link>
                                            </OverlayTrigger>
                                        </div>
                                    </Form.Group>
                                ))}
                            </Row> */}

                                {warning && <Form.Group className="mb-3">
                                    <Form.Label>Footer</Form.Label>
                                    <Form.Control type="text" disabled name="footer" value={`This code expires in ${authValues.warning_expiryTime} minutes.`} />
                                </Form.Group>}

                                {disclaimer && <Form.Group className="mb-3">
                                    <Form.Label>Button Text</Form.Label>
                                    <p className="fw-light m-0"><MdOutlineContentCopy /> Copy Code</p>
                                    <Form.Control type="text" className="w-25" required placeholder="Enter OTP" name="disclaimer_otp" onChange={handleAuthValues} value={authValues.disclaimer_otp} />
                                </Form.Group>}
                            </div>
                        }
                        {/* <<<<<<<<<<<<<<<<-----------------------------------AUTHENTICATION--ends----------------------------->>>>>>>>>>>>>>>>>>>> */}


                        {/* <<<<<<<<<<<<<<<<-----------------------------------MARKETING / UTILITY------------------------------->>>>>>>>>>>>>>>>>>>> */}
                        {category !== 'Authentication' && <div className="card p-3 mt-3 m-0">
                            {/* <<<<<<<<<<<------------LTO------------->>>>>>>>>>>>>>> */}
                            {format === 'limited_time_offer' &&
                                <>
                                    <Form.Group className="mb-3">
                                        <Form.Label>LTO Text<span className="text-danger"> * </span></Form.Label>
                                        <Select
                                            onChange={(selectedOption) => handleLTOText({ target: { value: selectedOption?.value || '' } })}
                                            options={[
                                                { value: "Valid for 1 Minute.", label: "Valid for 1 Minute." },
                                                { value: "Valid for 2 Minutes.", label: "Valid for 2 Minutes." },
                                                { value: "Valid for 5 Minutes.", label: "Valid for 5 Minutes." },
                                                { value: "Valid for 10 Minutes.", label: "Valid for 10 Minutes." },
                                                { value: "Valid for 15 Minutes.", label: "Valid for 15 Minutes." },
                                                { value: "Valid for 20 Minutes.", label: "Valid for 20 Minutes." },
                                                { value: "Valid for 30 Minutes.", label: "Valid for 30 Minutes." },
                                                { value: "Valid for 45 Minutes.", label: "Valid for 45 Minutes." },
                                                { value: "Valid for 60 Minutes.", label: "Valid for 60 Minutes." },
                                                { value: "Valid for 90 Minutes.", label: "Valid for 90 Minutes." },
                                            ]}
                                            placeholder="Select LTO Text"
                                            styles={{
                                                control: (provided, state) => ({
                                                    ...provided,
                                                    borderColor: validated && !setLTOText ? '#dc3545' : validated && setLTOText ? '#65BB82' : provided.borderColor,
                                                    borderRadius: '0.75rem',
                                                }),
                                            }}
                                        />
                                    </Form.Group>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Add Expiration Time<span className="text-danger"> * </span></Form.Label>
                                        <Form.Check
                                            type="radio"
                                            label="Yes"
                                            id="switch1"
                                            name="expity_time"
                                            defaultChecked
                                        />
                                        <Form.Check
                                            type="radio"
                                            label="No"
                                            id="switch2"
                                            name="expity_time"
                                            disabled
                                        />
                                    </Form.Group>
                                </>
                            }
                            <Form.Group className="mb-3 withChars">
                                <div className="d-flex justify-content-between">
                                    <Form.Label>Content Body<span className="text-danger"> * </span></Form.Label>
                                    <Button onClick={AddVars} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} variant="secondary" className="d-flex align-items-center text-success fw-bold">
                                        <FcPlus className="icon icon-xs me-2" />Add Variable
                                    </Button>
                                </div>
                                <Form.Control as="textarea" rows="7" required placeholder="Enter Message Content with variables as {{1}}." name="template_content" maxLength={1032} onChange={handleform2} />
                                <p className="chars_count ta">{FormFields.template_content === undefined ? "0" : FormFields.template_content.length}/1032</p>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a Message Content.
                                </Form.Control.Feedback>
                            </Form.Group>

                            <Row>
                                {inputFields.map((input, index) => (
                                    <Form.Group as={Col} xs={6} md={4} key={index} className="mb-2">
                                        <Form.Label className="fw-normal">{`Var {{${index + 1}}}`}<span className="text-danger"> * </span></Form.Label>
                                        <div className="d-flex align-items-center">
                                            <Form.Control
                                                type="text"
                                                placeholder="Value"
                                                value={input}
                                                onChange={(event) => handleInputChange(index, event)}
                                                name="template_variables"
                                            />
                                            <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                <Card.Link className="ms-2 hover-text-danger" onClick={() => handleDeleteBodyInput(index)}>
                                                    <XCircleIcon className="icon icon-xs" />
                                                </Card.Link>
                                            </OverlayTrigger>
                                        </div>
                                    </Form.Group>
                                ))}
                            </Row>

                            {format === 'interactive' && category !== 'Authentication' && <Form.Group className="mb-3 mt-2 withChars">
                                <Form.Label>Footer<span className="text-danger"> * </span></Form.Label>
                                <Form.Control type="text" required placeholder="Enter Footer" maxLength={60} name="footer" onChange={handleform2} />
                                <p className="chars_count ta">{FormFields.footer === undefined ? "0" : FormFields.footer.length}/60</p>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a Footer.
                                </Form.Control.Feedback>
                            </Form.Group>}
                        </div>}

                        {/* <<<<<<<<<<<<<<<<-----------------------------------carousel-cards------------------------------>>>>>>>>>>>>>>>>>>>> */}
                        {format === 'carousel' && category === 'Marketing' &&
                            <div className="card p-3 mt-3 m-0">
                                <Row className="">
                                    <Form.Group as={Col}>
                                        <Button onClick={handleCreateCard} variant="gray-200" className="">Create Cards<PlusIcon className="icon icon-xs ms-2" /></Button>
                                    </Form.Group>
                                    <Dropdown as={Col} className="d-flex">
                                        <Dropdown.Toggle as={Button} disabled={!cards.length > 0} variant="gray-200" className="d-inline-flex alignpitems-center ms-auto arrow-none">
                                            Add Buttons<ChevronDownIcon className="icon icon-xs ms-1" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start mt-2 p-2">
                                            <Dropdown.Item className="d-flex align-items-center hover-info" onClick={() => ChooseCardBtnType('quick_reply')}>
                                                Quick Reply
                                            </Dropdown.Item>
                                            <Dropdown.Divider as="div" className="my-1" />
                                            <Dropdown.Item as="div" className="d-flex align-items-start flex-column nestedDropdown">
                                                Call-to-action
                                                <ul className="list-unstyled ms-2 mt-2 mb-0">
                                                    <li onClick={() => ChooseCardBtnType('static')}>
                                                        <p className="dropdown-link">
                                                            Visit Website
                                                        </p>
                                                    </li>
                                                    <li onClick={() => ChooseCardBtnType('call_to_action')}>
                                                        <p className="dropdown-link">
                                                            Call Phone Number
                                                        </p>
                                                    </li>
                                                </ul>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Row>

                                {cards.map((card, cardIndex) => (
                                    <div className="p-2 mt-3 m-0" key={cardIndex}>
                                        {/* <> */}
                                        <div className="d-flex align-items-center pb-2 justify-content-between">
                                            <Form.Label className="fw-normal m-0">{`Card ${cardIndex + 1}`}</Form.Label>
                                            <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Remove Card</Tooltip>}>
                                                <Card.Link className="ms-2 hover-text-danger" onClick={() => handleDeleteCard(cardIndex)}>
                                                    <XCircleIcon className="icon icon-xs" />
                                                </Card.Link>
                                            </OverlayTrigger>
                                        </div>
                                        <div className="card input-card m-0">
                                            <Form.Group className="mb-2">
                                                <div className="d-flex justify-content-between align-items-start">
                                                    <Form.Label className="m-0">Card Body</Form.Label>
                                                    <Button onClick={() => AddCardBodyVars(cardIndex)} bsPrefix="text" style={{ border: "none", background: "none", padding: 0, color: "inherit" }} className="d-flex align-items-center text-success fw-bold">
                                                        <FcPlus className="icon icon-xs me-2" />Add Variable
                                                    </Button>
                                                </div>
                                                <Form.Control as="textarea" rows={5} required placeholder="Enter Card Content" maxLength={1032} value={card.body.text} onChange={(e) => handleCardBodyChange(cardIndex, e)} />
                                            </Form.Group>
                                            <Row>
                                                {/* variables */}
                                                {card.body.example.map((variable, varIndex) => (
                                                    <Form.Group as={Col} xs={6} md={4} key={varIndex} className="mb-2">
                                                        <Form.Label className="fw-normal">{`Var {{${varIndex + 1}}}`}<span className="text-danger"> * </span></Form.Label>
                                                        <div className="d-flex align-items-center">
                                                            <Form.Control
                                                                type="text"
                                                                placeholder="Value"
                                                                value={variable}
                                                                onChange={(e) => handleCardBodyVarsChange(cardIndex, varIndex, e)}
                                                                name="template_variables"
                                                            />
                                                            <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                <Card.Link className="ms-2 hover-text-danger" onClick={() => handleDeleteCardBodyVars(cardIndex, varIndex)}>
                                                                    <XCircleIcon className="icon icon-xs" />
                                                                </Card.Link>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </Form.Group>
                                                ))}
                                            </Row>
                                            {/* buttons */}
                                            {card.buttons.length > 0 &&
                                                <div className="my-2">
                                                    <Form.Label className="m-0">Buttons</Form.Label>
                                                    {card.buttons.map((button, buttonIndex) => (
                                                        <div key={buttonIndex}>
                                                            {button.type === "quick_reply" && (
                                                                <Form.Group className="d-flex align-items-center mb-2 w-100">
                                                                    <Form.Control
                                                                        type="text"
                                                                        required
                                                                        placeholder={`Text Button`}
                                                                        value={button.text}
                                                                        onChange={(e) => handleCardBtnChange(cardIndex, buttonIndex, "text", e.target.value)}
                                                                    />
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                        <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteCardButton(buttonIndex)}>
                                                                            <XCircleIcon className="icon icon-xs" />
                                                                        </Card.Link>
                                                                    </OverlayTrigger>
                                                                </Form.Group>
                                                            )}

                                                            {(button.type === "static" || button.type === "dynamic") && (
                                                                <div className="d-flex align-items-start gap-2 mb-2">
                                                                    <div className="d-flex gap-2 w-50">
                                                                        <Select
                                                                            value={{ value: button.type || 'static', label: button.type === 'dynamic' ? 'Dynamic' : 'Static' }}
                                                                            onChange={(selectedOption) => handleCardBtnChange(cardIndex, buttonIndex, 'type', selectedOption?.value || 'static')}
                                                                            options={[
                                                                                { value: "static", label: "Static" },
                                                                                { value: "dynamic", label: "Dynamic" },
                                                                            ]}
                                                                            placeholder="Select"
                                                                            className="w-50"
                                                                        />
                                                                        <Form.Control
                                                                            type="text"
                                                                            required
                                                                            placeholder={`URL Button text`}
                                                                            value={button.label}
                                                                            onChange={(e) => handleCardBtnChange(cardIndex, buttonIndex, 'label', e.target.value)}
                                                                            className="w-50"
                                                                        />
                                                                    </div>
                                                                    <div className=" d-flex align-items-center w-50">
                                                                        {button.type !== 'dynamic' ?
                                                                            <Form.Control
                                                                                type="url"
                                                                                required
                                                                                placeholder="https://example.com"
                                                                                value={button.website}
                                                                                onChange={(e) => handleCardBtnChange(cardIndex, buttonIndex, 'website', e.target.value)}
                                                                            />
                                                                            :
                                                                            <div className="d-block">
                                                                                <Form.Control
                                                                                    type="url"
                                                                                    required
                                                                                    className="mb-2"
                                                                                    placeholder="https://www.example.com/{{1}}"
                                                                                    value={button.website}
                                                                                    onChange={(e) => handleCardBtnChange(cardIndex, buttonIndex, 'website', e.target.value)}
                                                                                />
                                                                                <Form.Control
                                                                                    type="url"
                                                                                    required
                                                                                    placeholder="example url"
                                                                                    value={button.website_example}
                                                                                    onChange={(e) => handleCardBtnChange(cardIndex, buttonIndex, 'website_example', e.target.value)}
                                                                                />
                                                                            </div>}
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                            <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteCardButton(buttonIndex)}>
                                                                                <XCircleIcon className="icon icon-xs" />
                                                                            </Card.Link>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </div>
                                                            )}

                                                            {button.type === "call_to_action" && (
                                                                <div className="d-flex align-items-center gap-2 mb-2">
                                                                    <div className="d-flex w-50">
                                                                        <Form.Control
                                                                            type="text"
                                                                            required
                                                                            placeholder="Call Button text"
                                                                            value={button.label}
                                                                            onChange={(e) => handleCardBtnChange(cardIndex, buttonIndex, 'label', e.target.value)}
                                                                        />
                                                                    </div>
                                                                    <div className="d-flex w-50">
                                                                        <PhoneInput
                                                                            country={"in"}
                                                                            required
                                                                            value={button.contact_no}
                                                                            onChange={(num) => handleCardBtnChange(cardIndex, buttonIndex, 'contact_no', `+${num}`)}
                                                                            placeholder="+91 99999-99999"
                                                                            className="phone-input"
                                                                            autoComplete="new-phone"
                                                                        />
                                                                        <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                            <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteCardButton(buttonIndex)}>
                                                                                <XCircleIcon className="icon icon-xs" />
                                                                            </Card.Link>
                                                                        </OverlayTrigger>
                                                                    </div>
                                                                </div>

                                                            )}
                                                        </div>
                                                    ))}
                                                </div>
                                            }
                                        </div>
                                    </div>
                                ))}
                            </div>
                        }
                        {/* <<<<<<<<<<<<<<<<-----------------------------------carousel-cards-end----------------------------->>>>>>>>>>>>>>>>>>>> */}


                        {/* <<<<<<<<<<<<<<<<-----------------------------------BUTTONS------------------------------->>>>>>>>>>>>>>>>>>>> */}
                        {(category !== 'Authentication' && format === 'interactive') ?  //marketing + utility
                            // for interactive type, optional buttons
                            <div className="card p-3 mt-3 m-0">
                                <Row>
                                    <Form.Group as={Col}>
                                        <Form.Label htmlFor="basic-url">Button (Optional)</Form.Label>
                                    </Form.Group>
                                    <Dropdown as={Col} className="d-flex">
                                        <Dropdown.Toggle as={Button} variant="gray-200" className="d-inline-flex alignpitems-center arrow-none ms-auto">
                                            Add Buttons<ChevronDownIcon className="icon icon-xs ms-1" />
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start mt-2 p-2">
                                            <Dropdown.Item variant="gray-200" className={formButtons.length > 0 && textButtons.length < 10 ? "d-flex align-items-center hover-info notAllowed" : "d-flex align-items-center hover-info"} onClick={() => ChooseBtnType('text')}>
                                                Quick Reply: {textButtons.length}/10
                                            </Dropdown.Item>
                                            <Dropdown.Divider as="div" className="my-1" />
                                            <Dropdown.Item as="div" className="d-flex align-items-start flex-column nestedDropdown">
                                                Call-to-action
                                                <ul className="list-unstyled ms-2 mt-2 mb-0">
                                                    <li onClick={() => formButtons.length === 0 && urlButtons.length < 2 && ChooseBtnType('url')}>
                                                        <p className={formButtons.length > 0 || urlButtons.length >= 2 ? "dropdown-link notAllowed" : "dropdown-link"}>
                                                            Visit Website: {urlButtons.length}/2
                                                        </p>
                                                    </li>
                                                    <li onClick={() => formButtons.length === 0 && phoneButtons.length < 1 && ChooseBtnType('phone')}>
                                                        <p className={formButtons.length > 0 || phoneButtons.length >= 1 ? "dropdown-link notAllowed" : "dropdown-link"}>
                                                            Call Phone Number: {phoneButtons.length}/1
                                                        </p>
                                                    </li>
                                                    <li
                                                    // onClick={() => textButtons.length === 0 && urlButtons.length === 0 && phoneButtons.length === 0 && formButtons.length < 1 && ChooseBtnType('form')}
                                                    >
                                                        <p className={textButtons.length > 0 || urlButtons.length > 0 || phoneButtons.length > 0 || formButtons.length === 1 ? 'dropdown-link notAllowed' : 'dropdown-link'}>
                                                            Complete Form: {formButtons.length}/1
                                                        </p>
                                                    </li>
                                                </ul>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Row>

                                {textButtons.length > 0 && <div className="p-0 m-0 mt-2 border-1">
                                    <Form.Label className="fw-bold">Quick Reply</Form.Label>
                                    <div className="card input-card p-2 m-0 pt-3 border-1">
                                        {textButtons.map((button, index) => (
                                            <Form.Group key={button.id} className="d-flex align-items-center mb-2 w-100">
                                                <Form.Control
                                                    type="text"
                                                    required
                                                    placeholder={`Button ${index + 1}`}
                                                    onChange={(e) => handleFormChange('text', button.id, 'text', e.target.value)}
                                                />
                                                <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                    <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteButton('text', button.id)}>
                                                        <XCircleIcon className="icon icon-xs" />
                                                    </Card.Link>
                                                </OverlayTrigger>
                                            </Form.Group>
                                        ))}
                                    </div>
                                </div>}

                                {(urlButtons.length > 0 || phoneButtons.length > 0) &&
                                    <div className="p-0 mt-2 m-0">
                                        <Form.Label className="fw-bold">Call-to-action</Form.Label>
                                        <div className="card input-card p-2 m-0 border-1">
                                            {urlButtons.length > 0 && <div className="mb-1">
                                                <Form.Label>URL</Form.Label>
                                                {urlButtons.map((button, index) => (
                                                    <div key={button.id} className="d-flex align-items-start mb-2 w-100 gap-2">
                                                        <div className="d-flex gap-2 w-50">
                                                            <Select
                                                                onChange={(selectedOption) => handleFormChange('url', button.id, 'type', selectedOption?.value || 'static')}
                                                                options={[
                                                                    { value: "static", label: "Static" },
                                                                    { value: "dynamic", label: "Dynamic" },
                                                                ]}
                                                                placeholder="Select"
                                                                className="w-50"
                                                            />

                                                            <Form.Control
                                                                type="text"
                                                                required
                                                                placeholder={`Button text ${index + 1}`}
                                                                onChange={(e) => handleFormChange('url', button.id, 'label', e.target.value)}
                                                                className="w-50"
                                                            />
                                                        </div>
                                                        <div className="d-flex align-items-center w-50">
                                                            {button.type !== 'dynamic' ?
                                                                <Form.Control
                                                                    type="url"
                                                                    required
                                                                    placeholder="https://example.com"
                                                                    onChange={(e) => handleFormChange('url', button.id, 'website', e.target.value)}
                                                                />
                                                                :
                                                                <div className="d-block">
                                                                    <Form.Control
                                                                        type="url"
                                                                        required
                                                                        className="mb-2"
                                                                        placeholder="https://www.example.com/{{1}}"
                                                                        onChange={(e) => handleFormChange('url', button.id, 'website', e.target.value)}
                                                                    />
                                                                    <Form.Control
                                                                        type="url"
                                                                        required
                                                                        placeholder="example url"
                                                                        onChange={(e) => handleFormChange('url', button.id, 'website_example', e.target.value)}
                                                                    />
                                                                </div>}
                                                            <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteButton('url', button.id)}>
                                                                    <XCircleIcon className="icon icon-xs" />
                                                                </Card.Link>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>}

                                            {phoneButtons.length > 0 && <div className="mb-1">

                                                <Form.Label>Phone Number</Form.Label>
                                                {phoneButtons.map((button) => (
                                                    <div key={button.id}>
                                                        <div className="d-flex align-items-center gap-2 mb-2">
                                                            <div className="d-flex w-50">
                                                                <Form.Control
                                                                    type="text"
                                                                    required
                                                                    placeholder="Button text"
                                                                    onChange={(e) => handleFormChange('phone', button.id, 'label', e.target.value)}
                                                                />
                                                            </div>
                                                            <div className="d-flex w-50">
                                                                <PhoneInput
                                                                    country={"in"}
                                                                    required
                                                                    onChange={(num) => handleFormChange('phone', button.id, 'contact_no', `+${num}`)}
                                                                    placeholder="+91 99999-99999"
                                                                    className="phone-input"
                                                                    autoComplete="new-phone"
                                                                />
                                                                <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                    <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteButton('phone', button.id)}>
                                                                        <XCircleIcon className="icon icon-xs" />
                                                                    </Card.Link>
                                                                </OverlayTrigger>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>}
                                        </div>

                                        {formButtons.map((button) => (
                                            <div key={button.id}>
                                                <Form.Label>Complete Form</Form.Label>
                                                <Row>
                                                    <Col md={11}>
                                                        <Row>
                                                            <Col md={8} className="pe-0">
                                                                <Form.Control
                                                                    type="text"
                                                                    required
                                                                    placeholder="Form Name"
                                                                    onChange={(e) => handleFormChange('form', button.id, 'formName', e.target.value)}
                                                                />
                                                            </Col>
                                                            <Col md={4} className="pe-0">
                                                                <Button variant="outline-success rounded-pill" onClick={toggleCreateFormModal}>Create Form</Button>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col md={1} className="d-flex align-items-center">
                                                        <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                            <Card.Link className="hover-text-danger" onClick={() => deleteButton('form', button.id)}>
                                                                <XCircleIcon className="icon icon-xs" />
                                                            </Card.Link>
                                                        </OverlayTrigger>
                                                    </Col>
                                                </Row>
                                                {showCreateFormModal && (
                                                    <CreateForm
                                                        show={showCreateFormModal}
                                                        onHide={toggleCreateFormModal}
                                                    />
                                                )}
                                            </div>
                                        ))}
                                    </div>}
                            </div>
                            :
                            // for LTO type, buttons are fixed
                            (category !== 'Authentication' && format === 'limited_time_offer') ?
                                <div className="card p-3 mt-3 m-0">
                                    <Row>
                                        <Form.Group as={Col}>
                                            <Form.Label htmlFor="basic-url">Buttons</Form.Label>
                                        </Form.Group>
                                    </Row>
                                    <Form.Label className="fw-bold mt-2">Copy Code</Form.Label>
                                    <Form.Group className="mb-3 card input-card p-2 m-0 border-1">
                                        <Form.Label>Copy Code Text</Form.Label>
                                        <Form.Control type="text" required placeholder="Enter Coupon Code" pattern="[a-zA-Z0-9]{0,16}" onChange={(e) => handleLTOBtn('code', 'example', e.target.value)} value={ltoBtns[0].example} />
                                        <Form.Control.Feedback type="invalid">
                                            Please provide a valid Code (alphanumeric with 16 characters).
                                        </Form.Control.Feedback>
                                        <p className="chars_count">{ltoBtns[0].example === undefined ? "0" : ltoBtns[0].example.length}/75</p>
                                    </Form.Group>


                                    <Form.Label className="mt-2 fw-bold">Call-to-action</Form.Label>
                                    <div className="mb-3 card input-card p-2 m-0 border-1">
                                        <Form.Label>URL</Form.Label>
                                        <div className="d-flex align-items-start mb-2 w-100 gap-2">
                                            <div className="d-flex gap-2 w-50">
                                                <Select
                                                    onChange={(selectedOption) => handleLTOBtn('url', 'type', selectedOption?.value || 'static')}
                                                    options={[
                                                        { value: "static", label: "Static" },
                                                        { value: "dynamic", label: "Dynamic" },
                                                    ]}
                                                    placeholder="Select"
                                                />

                                                <Form.Control
                                                    type="text"
                                                    required
                                                    placeholder='Button text'
                                                    onChange={(e) => handleLTOBtn('url', 'label', e.target.value)}
                                                />
                                            </div>
                                            <div className="d-flex align-items-center w-50">
                                                {ltoBtns[1].type !== 'dynamic' ?
                                                    <Form.Control
                                                        type="url"
                                                        required
                                                        placeholder="https://example.com"
                                                        onChange={(e) => handleLTOBtn('url', 'website', e.target.value)}
                                                    />
                                                    :
                                                    <div className="d-block">
                                                        <Form.Control
                                                            type="url"
                                                            required
                                                            className="mb-2"
                                                            placeholder="https://www.example.com/{{1}}"
                                                            onChange={(e) => handleLTOBtn('url', 'website', e.target.value)}
                                                        />
                                                        <Form.Control
                                                            type="url"
                                                            required
                                                            placeholder="example url"
                                                            onChange={(e) => handleLTOBtn('url', 'website_example', e.target.value)}
                                                        />
                                                    </div>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                :
                                // buttons for COPY CODE : 1 fixed 1 optional 
                                (category !== 'Authentication' && format === 'copy_code') ?
                                    <div className="card p-3 mt-3 m-0">
                                        <Row className="pb-3">
                                            <Form.Group as={Col}>
                                                <Form.Label htmlFor="basic-url">Button(s)</Form.Label>
                                            </Form.Group>
                                            <Dropdown as={Col} className="d-flex">
                                                <Dropdown.Toggle as={Button} disabled={codeBtns.length > 1} variant="gray-200" className="d-inline-flex alignpitems-center arrow-none ms-auto">
                                                    Add Button<ChevronDownIcon className="icon icon-xs ms-1" />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu className="dashboard-dropdown dropdown-menu-start mt-2 p-2">
                                                    <Dropdown.Item className="d-flex align-items-center hover-info" onClick={() => ChooseCodeBtnType('quick_reply')}>
                                                        Quick Reply
                                                    </Dropdown.Item>
                                                    <Dropdown.Divider as="div" className="my-1" />
                                                    <Dropdown.Item as="div" className="d-flex align-items-start flex-column nestedDropdown">
                                                        Call-to-action
                                                        <ul className="list-unstyled ms-2 mt-2 mb-0">
                                                            <li onClick={() => ChooseCodeBtnType('url')}>
                                                                <p className="dropdown-link">
                                                                    Visit Website
                                                                </p>
                                                            </li>
                                                            <li onClick={() => ChooseCodeBtnType('call_to_action')}>
                                                                <p className="dropdown-link">
                                                                    Call Phone Number
                                                                </p>
                                                            </li>
                                                        </ul>
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </Row>

                                        <div className="">
                                            <Form.Label className="fw-bold">Copy Code</Form.Label>
                                            <Form.Group className="mb-3 card input-card p-2 m-0">
                                                <Form.Label>Copy Code Text</Form.Label>
                                                <Form.Control type="text" required placeholder="Enter Coupon Code" pattern="\d{4,10}" onChange={(e) => handleCodeBtn('code', 'example', e.target.value)} value={codeBtns[0].example || ''} />
                                                <p className="chars_count up">{codeBtns[0].example === undefined ? "0" : codeBtns[0].example.length}/75</p>
                                                <Form.Control.Feedback type="invalid">
                                                    Please provide a valid Code (enter a number with 4 to 10 digits).
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        </div>

                                        {codeBtns.length > 1 && <div>
                                            {(codeBtns[1].type === 'quick_reply') ?
                                                <div className="card input-card p-2 m-0">
                                                    <Form.Label className="fw-bold">Quick Reply</Form.Label>
                                                    <Form.Group className="d-flex align-items-center mb-2">
                                                        <Form.Control
                                                            type="text"
                                                            required
                                                            placeholder={'Button Text'}
                                                            onChange={(e) => handleCodeBtn('quick_reply', 'text', e.target.value)}
                                                        />
                                                        <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                            <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteCodeBtn('quick_reply')}>
                                                                <XCircleIcon className="icon icon-xs" />
                                                            </Card.Link>
                                                        </OverlayTrigger>
                                                    </Form.Group>
                                                </div>
                                                : (codeBtns[1].type === 'static' || codeBtns[1].type === 'dynamic') ?
                                                    <div className="p-0 mt-2 m-0">
                                                        <Form.Label className="fw-bold">Call-to-action</Form.Label>
                                                        <div className="card input-card p-2 m-0 border-1">
                                                            <Form.Label>URL</Form.Label>
                                                            <div className="d-flex align-items-start mb-2 w-100 gap-2">
                                                                <div className="d-flex gap-2 w-50">
                                                                    <Select
                                                                        onChange={(selectedOption) => handleCodeBtn('url', 'type', selectedOption?.value)}
                                                                        options={[
                                                                            { value: "static", label: "Static" },
                                                                            { value: "dynamic", label: "Dynamic" },
                                                                        ]}
                                                                        placeholder="Select"
                                                                        className="w-50"
                                                                    />
                                                                    <Form.Control
                                                                        type="text"
                                                                        required
                                                                        className="w-50"

                                                                        placeholder={'Button text'}
                                                                        onChange={(e) => handleCodeBtn('url', 'label', e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="d-flex align-items-center w-50">
                                                                    {codeBtns[1].type !== 'dynamic' ? <>
                                                                        <Form.Control
                                                                            type="url"
                                                                            required
                                                                            placeholder="https://example.com"
                                                                            onChange={(e) => handleCodeBtn('url', 'website', e.target.value)}
                                                                        />
                                                                    </> :
                                                                        <div className="d-block">
                                                                            <Form.Control
                                                                                type="url"
                                                                                required
                                                                                className="mb-2"
                                                                                placeholder="https://www.example.com/{{1}}"
                                                                                onChange={(e) => handleCodeBtn('url', 'website', e.target.value)}
                                                                            />
                                                                            <Form.Control
                                                                                type="url"
                                                                                required
                                                                                placeholder="example url"
                                                                                onChange={(e) => handleCodeBtn('url', 'website_example', e.target.value)}
                                                                            />
                                                                        </div>}

                                                                    <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                        <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteCodeBtn(codeBtns[1].type)}>
                                                                            <XCircleIcon className="icon icon-xs" />
                                                                        </Card.Link>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="p-0 mt-2 m-0">
                                                        <Form.Label className="fw-bold">Call-to-action</Form.Label>
                                                        <div className="card input-card p-2 m-0 border-1">
                                                            <Form.Label>Phone Number</Form.Label>
                                                            <div className="d-flex align-items-start mb-2 w-100 gap-2">
                                                                <div className="d-flex w-50">
                                                                    <Form.Control
                                                                        type="text"
                                                                        required
                                                                        placeholder="Button text"
                                                                        onChange={(e) => handleCodeBtn('call_to_action', 'label', e.target.value)}
                                                                    />
                                                                </div>
                                                                <div className="d-flex w-50">
                                                                    <PhoneInput
                                                                        country={"in"}
                                                                        required
                                                                        onChange={(num) => handleCodeBtn('call_to_action', 'contact_no', `+${num}`)}
                                                                        placeholder="+91 99999-99999"
                                                                        className="phone-input"
                                                                        autoComplete="new-phone"
                                                                    />
                                                                    <OverlayTrigger placement="top" overlay={<Tooltip className="m-0">Delete</Tooltip>}>
                                                                        <Card.Link className="ms-2 hover-text-danger" onClick={() => deleteCodeBtn('call_to_action')}>
                                                                            <XCircleIcon className="icon icon-xs" />
                                                                        </Card.Link>
                                                                    </OverlayTrigger>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                            }
                                        </div>}

                                    </div>
                                    : <></>
                            // for carousel type this should not render
                        }


                        {/* <<<<<<<<<<<<<<<<<<------------------------------------FORM COMPLETE---------------------------------------------->>>>>>>>>>>>>>>>> */}


                        <div className="d-flex mt-3 justify-content-end">
                            {/* <Button variant="secondary" className="animate-up-2 me-2">
                                Send Approval
                            </Button> */}
                            <Button variant="success" type="submit" className="text-white animate-up-2 m-1">
                                Submit
                            </Button>
                        </div>
                    </div>
                </Form >

            </div >


            {/* after API Hit */}
            < Modal
                centered
                show={showModal}
                onHide={handleCloseModal}
                className={`modal-${variant}`}
                backdrop="static"
                keyboard={false}
            >
                <Modal.Header className="mx-auto">
                    <p className="lead mb-0 text-white">Creating WhatsApp Template</p>
                </Modal.Header>
                <Modal.Body className="pt-0">
                    <div className="py-3 px-5 text-center">
                        {progress !== 100 ?
                            (<span className="modal-icon display-1">
                                <ClockIcon className="icon icon-xl text-white" />
                            </span>) :
                            variant === 'tertiary' ?
                                (<span className="modal-icon display-1">
                                    <CheckCircleIcon className="icon icon-xl text-white" />
                                </span>) :
                                <span className="modal-icon display-1">
                                    <ShieldExclamationIcon className="icon icon-xl text-white" />
                                </span>
                        }

                        <Modal.Title className="text-white mb-3">
                            {progress !== 100 ? <h3>Sending Request</h3> : variant === 'tertiary' ? <h3>Template Created Successfully</h3> : <h3>Something Went Wrong</h3>}
                        </Modal.Title>
                        <ProgressBar variant="secondary" now={progress} min={0} max={100} animated />
                        {variant !== 'tertiary' ?
                            <p className="mb-4 text-danger">
                                {reason}
                            </p> : ''}
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-center pt-0 pb-3">
                    <Button variant="gray-200" size="sm" className="text-primary" onClick={handleRefresh}>
                        OK
                    </Button>
                    {variant !== 'tertiary' && <Button variant="gray-200" size="sm" className="text-primary fw-bold" onClick={handleCloseModal}>
                        Retry
                    </Button>}
                </Modal.Footer>
            </Modal >
        </Fragment >

    )
}